import { Swiper, SwiperSlide } from 'swiper/react';
import React, { useEffect, useState } from 'react';
import ProductCard from '../Components/ProductCards/ProductCard';
import { Pagination } from 'swiper';
import Product from '../Types/Product';
import ProductBlockNoSlider from './ProductBlockNoSlider';
import clsx from 'clsx';
import { getListingPricesJson } from '../Components/NavisionPrice/services/NavisionPriceService';
import { useTypedSelector } from '../Hooks/useTypedSelector';
import { getListingstocksJson } from '../Components/NavisionStock/services/NavisionStockService';
import { ProductStocks } from '../Components/NavisionStock/types/ProductStocks';
import useShowBothPrices from '../Hooks/useShowBothPrices';

interface ProductSliderProps {
  products: Product[];
}

const ProductSlider = ({ products }: ProductSliderProps) => {
  const [renderSlider, setRenderSlider] = useState(false);
  const [navisionPrices, setNavisionPrices] = useState<
    ProductPriceResponseItem[]
  >([]);
  const [navisionStocks, setNavisionStocks] = useState<ProductStocks[]>(
    []
  );
  const { currentType: currentPriceToggleType } = useTypedSelector(
    (state) => state.priceToggle
  );
  const showBothPrices = useShowBothPrices();
  const { isInBuyableState } = useTypedSelector(
    (state) => state.buyableState
  );

  useEffect(() => {
    const fetchData = async () => {
      const productIds: string[] = products?.map((p) => p?.id);
      if (currentPriceToggleType != null && productIds.length) {
        var result = await getListingstocksJson(productIds);
        if (result != null && result.success) {
          setNavisionStocks(result.items);
        } else {
          console.log(
            `Failed to fetch stock for productId: ${productIds.toString()}`
          );
        }
      }

      if (showBothPrices && productIds.length) {
        var prices = await getListingPricesJson(productIds);
        setNavisionPrices(prices);
      }
    };

    fetchData();
  }, [currentPriceToggleType, showBothPrices, products]);

  useEffect(() => setRenderSlider(true), []);

  return renderSlider ? (
    <Swiper
      spaceBetween={16}
      slidesPerView={1}
      slidesPerGroup={1}
      pagination={true}
      loop={false}
      modules={[Pagination]}
      breakpoints={{
        767: {
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
        1023: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        },
      }}
      className={clsx(
        products.length > 1 && 'sm-down:-mr-4',
        'product-swiper pb-8 [&_.swiper-pagination]:bottom-0 [&_.swiper-pagination]:h-auto [&_.swiper-slide]:h-auto [&_.swiper-wrapper]:pb-11'
      )}
    >
      {products.map((product, idx) => (
        <SwiperSlide key={product.id + 'slide' + idx}>
          <ProductCard
            product={product}
            lazyLoadImage={true}
            showBothPrices={showBothPrices}
            navisionStock={navisionStocks?.find(
              (p) => p?.productId === product?.id
            )}
            currentPriceToggleType={currentPriceToggleType}
            navisionPrice={navisionPrices?.find(
              (p) => p?.productId === product?.id
            )}
            isInBuyableState={isInBuyableState}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  ) : (
    //Render product block without slider on server to avoid layout shifting
    <div className="pb-8">
      <ProductBlockNoSlider
        products={products.slice(0, 4)}
        numPerRow={4}
      />
    </div>
  );
};

export default ProductSlider;
